
// const whiteList = ['/login', '/auth-redirect']
const whiteList = ['/home']
export default  whiteList
